import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const institutions = `${REACT_APP_API_PREFIX}/${service}/institutions`;

export function getInstitutions(filters) {
  const url = `${institutions}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getInstitutionById(id) {
  const url = `${institutions}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateInstitution(id, body) {
  const url = `${institutions}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteInstitution(id) {
  const url = `${institutions}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createInstitution(body) {
  const url = `${institutions}`;
  return {
    method: POST,
    url,
    body,
  };
}
